<template>
  <div id="userdetail-page" class="mb-5">
    <b-card>
      <b-row>
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/company-structure/branch">Branch</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doSubmit" class="mt-2">
        <b-row>
          <b-col md="5">
            <label class="labels">name *</label>
            <div class="form-group" v-bind:class="errors.has('name') ? 'has-error' : ''">
              <input
                type="text"
                class="form-control"
                v-bind:class="errors.has('name') ? 'is-invalid' : ''"
                v-validate="'required'"
                data-vv-as="name"
                name="name"
                v-model="model.name"
                placeholder="Name"
              />
              <p v-if="errors.has('name') !== null"></p>
            </div>
          </b-col>
          <b-col md="2"> </b-col>
          <b-col md="5">
            <label class="labels">company *</label>
            <div class="form-group" v-bind:class="errors.has('company') ? 'has-error' : ''">
              <b-form-select
                class="form-control"
                v-model="model.company"
                v-bind:class="errors.has('company') ? 'is-invalid' : ''"
                v-validate="'required'"
                name="company"
                :error="errors.first('company')"
                :options="companyList"
              ></b-form-select>
              <p v-if="errors.has('company') !== null"></p>
            </div>
          </b-col>
          <!--<b-col md="4">
                  <label class="labels">status office *</label>
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox switch class="mr-n2" name="isHq" v-model="model.isHq" @change="changeSwitch(model.isHq)">
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-form-input style="background-color:#fff!important;" readonly v-model="hq"></b-form-input>
                  </b-input-group>
                </b-col>-->
        </b-row>
        <b-row>
          <b-col md="5">
            <label class="labels">email *</label>
            <div class="form-group" v-bind:class="errors.has('email') ? 'has-error' : ''">
              <input
                type="email"
                class="form-control"
                v-bind:class="errors.has('email') ? 'is-invalid' : ''"
                v-validate="'required'"
                data-vv-as="email"
                name="email"
                v-model="model.email"
                placeholder="Ex: myname@example.com"
              />
              <p v-if="errors.has('email') !== null"></p>
            </div>
          </b-col>
          <b-col md="2"> </b-col>
          <b-col md="5">
            <label class="labels">fax *</label>
            <div class="form-group" v-bind:class="errors.has('fax') ? 'has-error' : ''">
              <input
                type="number"
                class="form-control"
                v-bind:class="errors.has('fax') ? 'is-invalid' : ''"
                v-validate="'required'"
                data-vv-as="fax"
                name="fax"
                v-model="model.fax"
                placeholder="Fax"
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label class="labels">Telephone *</label>
            <div class="form-group" v-bind:class="errors.has('phone') ? 'has-error' : ''">
              <input
                type="number"
                class="form-control"
                v-bind:class="errors.has('phone') ? 'is-invalid' : ''"
                v-validate="'required'"
                data-vv-as="phone"
                name="phone"
                v-model="model.phone"
                placeholder="Telephone"
              />
              <p v-if="errors.has('phone') !== null"></p>
            </div>
            <!--<label class="labels">email</label>
                  <div class="form-group" v-bind:class="errors.has('email') ? 'has-error':''">
                    <input type="email" class="form-control mr-1" v-bind:class="errors.has('email') ? 'is-invalid':''" v-validate="'required'" data-vv-as="email" name="email" v-model="model.email" placeholder="Email" />
                    <p v-if="errors.has('email') !== null" class="invalid-feedback">{{errors.first('email')}}</p>
                  </div>-->
          </b-col>
          <b-col md="1">
            <div class="form-group" v-bind:class="errors.has('extPhone') ? 'has-error' : ''">
              <input
                type="number"
                class="form-control label-ext"
                name="extPhone"
                v-model="model.extPhone"
                placeholder="Ext"
              />
            </div>
          </b-col>
          <b-col md="1"> </b-col>
          <b-col md="5">
            <label class="labels">address *</label>
            <div class="form-group" v-bind:class="errors.has('address') ? 'has-error' : ''">
              <b-form-textarea
                rows="3"
                class="form-control"
                v-bind:class="errors.has('address') ? 'is-invalid' : ''"
                v-validate="'required'"
                data-vv-as="address"
                name="address"
                v-model="model.address"
                placeholder="Address"
              />
              <p v-if="errors.has('address') !== null"></p>
            </div>
          </b-col>
        </b-row>
        <h5>Location</h5>
        <b-row>
          <b-col md="3">
            <label class="labels mt-3">latitude</label>
            <b-form-input
              type="text"
              v-model="model.latitude"
              placeholder="latitude"
            ></b-form-input>
            <label class="labels mt-3">longitude</label>
            <b-form-input
              type="text"
              v-model="model.longitude"
              placeholder="latitude"
            ></b-form-input>
            <label class="labels mt-3">geofence</label>
            <b-form-checkbox
              id="checkbox-1"
              v-model="model.geofence"
              name="checkbox-1"
              value="1"
              unchecked-value="0"
            >
              Use geofence for this Branch
            </b-form-checkbox>
            <div v-if="model.geofence === '1'">
              <label class="labels mt-2">Geofence radius (m)</label>
              <b-form-input
                type="text"
                v-model="model.geofenceRadius"
                placeholder="Enter radius (M)"
              ></b-form-input>
            </div>
          </b-col>
          <b-col md></b-col>
          <b-col md="8">
            <div id="app">
              <GmapMap
                :center="center"
                :zoom="18"
                map-style-id="roadmap"
                :options="mapOptions"
                style="width: 100vmin; height: 50vmin"
                ref="mapRef"
                @click="handleMapClick"
              >
                <GmapMarker
                  :position="marker.position"
                  :clickable="true"
                  :draggable="true"
                  @drag="handleMarkerDrag"
                  @click="panToMarker"
                />
              </GmapMap>
              <b-button variant="warning" class="mt-2" size="sm" @click="geolocate"
                >Detect Location</b-button
              >
            </div>
          </b-col>
        </b-row>
        <div class="mt-5 pt-3 mb-2">
          <b-button class="mr-2" @click="goBack" variant="secondary"
            ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
          >
          <b-button
            :variant="$route.params.id !== undefined ? 'warning' : 'primary'"
            class="btn-back float-right"
            type="submit"
            ><font-awesome-icon icon="save"></font-awesome-icon>
            {{ $route.params.id !== undefined ? 'Update' : 'Save' }}
          </b-button>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
// require('@/bootstrap')
import Vue from 'vue';
import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);

export default {
  name: 'branch-form',
  data() {
    return {
      marker: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },

      mapOptions: {
        disableDefaultUI: true,
      },
      showMapNow: true,
      isLoadingSearch: false,
      showLocationSearch: true,
      isLoading: false,
      apiUrl: {
        branch: window.AppConfig.apiUrl + 'branch',
      },
      coordinates: {
        lat: 0,
        lng: 0,
      },
      model: {
        // isHq: false,
        company: '',
        name: '',
        address: '',
        phone: '',
        extPhone: '',
        fax: '',
        email: '',
        geofence: 0,
        geofenceRadius: 60,
        latitude: 0,
        longitude: 0,
      },
      // google map config
      place: null,
      position: {
        lat: 0,
        lng: 0,
      },
      // hq: 'Branch',
      companyList: [
        {
          value: '',
          text: 'Please Select Company',
        },
      ],
      ip: null,
      // isHq: [
      //   {
      //     value: 0,
      //     text: 'Branch'
      //   },
      //   {
      //     value: 1,
      //     text: 'Headquarters'
      //   },
      // ],
    };
  },
  mounted() {
    this.initData();
    this.geolocate();
  },

  methods: {
    initData() {
      if (this.$route.params.id !== undefined) {
        this.getDetail();
      }
    },

    //detects location from browser
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      
        this.model.latitude = position.coords.latitude;
        this.model.longitude = position.coords.longitude;
        this.panToMarker();
      });
    },

    saveGeolocate() {},

    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      this.model.latitude = e.latLng.lat();
      this.model.longitude = e.latLng.lng();
    },

    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
      this.$refs.mapRef.setZoom(18);
    },

    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      console.log(e);
    },

    getDetail() {
      this.isLoading = true;
      this.$http
        .get(this.apiUrl.branch + '/' + this.$route.params.id)
        .then((response) => {
          this.model.name = response.data.name !== null ? response.data.name : '-';
          this.model.company = response.data.company !== null ? response.data.company.uuid : '-';
          this.model.address = response.data.address !== null ? response.data.address : '-';
          this.model.phone = response.data.phone !== null ? response.data.phone : '-';
          this.model.extPhone = response.data.extPhone !== null ? response.data.extPhone : '-';
          this.model.fax = response.data.fax !== null ? response.data.fax : '-';
          this.model.email = response.data.email !== null ? response.data.email : '-';
          this.model.geofenceRadius =
            response.data.geofenceRadius !== null ? response.data.geofenceRadius : '-';
          this.model.geofence = response.data.geofence !== null ? response.data.geofence : '-';
          this.model.latitude = response.data.latitude !== null ? response.data.latitude : '-';
          this.model.longitude = response.data.longitude !== null ? response.data.longitude : '-';
          if (response.data.geofence === true) {
            this.model.geofence = 1;
          }
          if (response.data.geofence === false) {
            this.model.geofence = 0;
          }

          // this.model.isHq = response.data.isHq === '1' ? true : false
          // this.hq = response.data.isHq === '1' ? this.isHq[1].text : this.isHq[0].text
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    deleteLocation() {
      (this.model.latitude = 0), (this.model.longitude = 0), (this.showLocationSearch = false);
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm A');
      } else {
        return '-';
      }
    },
    goBack() {
      window.goBack(this);
    },
    // changeSwitch (val) {
    //   if(val){
    //     this.model.isHq = !val
    //     this.hq = this.isHq[0].text
    //   }else{
    //     this.model.isHq = !val
    //     this.hq = this.isHq[1].text
    //   }
    // },
    doSubmit() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.$route.params.id !== undefined) {
            this.$http
              .patch(this.apiUrl.branch + '/' + this.$route.params.id, this.model)
              .then((response) => {
                this.$store.dispatch('notification/success', 'Branch has been updated.');
                window.location.href = document.URL.replace('/edit', '');
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
              });
          } else {
            this.$http
              .post(this.apiUrl.branch, this.model)
              .then((response) => {
                this.$store.dispatch('notification/success', 'Branch has been added.');
                window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
              });
          }
        } else {
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
        }
      });
    },
    getCompany() {
      this.$http.get(window.AppConfig.apiUrl + 'company').then((response) => {
        response.data._embedded.company.forEach((data) => {
          this.companyList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },
  },
};
</script>
